module.exports = __webpack_public_path__ + "static/head2-77dbf5cf1be073e7a74c498bfb1ef4b8.png";